const rankings = [
  { rank: 1, title: '顶流小生深夜密会神秘女郎，粉丝集体塌房求真相', heat: '128.6万', trend: 'up', change: '+12位' },
  { rank: 2, title: '某综艺节目录制现场导演与嘉宾爆发激烈争吵', heat: '96.3万', trend: 'up', change: '+5位' },
  { rank: 3, title: '百万粉丝美妆博主涉嫌虚假宣传，质检报告曝光', heat: '83.1万', trend: 'down', change: '-1位' },
  { rank: 4, title: '某选秀节目投票系统遭质疑，粉丝晒数据异常证据', heat: '71.5万', trend: 'up', change: '+8位' },
  { rank: 5, title: '两大头部主播隔空互怼升级，互相揭底刷单买粉', heat: '65.8万', trend: 'new', change: '新上榜' },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-primary-500 text-background-50';
    if (rank === 2) return 'bg-primary-400 text-background-50';
    if (rank === 3) return 'bg-accent-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500 text-sm"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
    return <i className="ri-sparkling-line text-accent-500 text-sm"></i>;
  };

  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          基于全网讨论热度的黑料事件实时排名
        </p>

        <div className="space-y-2">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
                <span className="flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap">
                  {getTrendIcon(item.trend)}
                  <span>{item.change}</span>
                </span>
                <span className="text-xs font-semibold text-primary-600 whitespace-nowrap min-w-[60px] text-right">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}